import React from 'react'

const AddCourse = () => {
  return (
    <div>AddCourse</div>
  )
}

export default AddCourse;